import { Injectable } from "@angular/core";
import { MedOptionType } from "@mk/med-ui";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { env } from "@environments/environment";

interface SuppliesFilterModel {
  agreementNum: string[]
  status: string[]
  direction: string[]
  subDirection: string[]
  mnn: string[]
  warehouse: string[]
  supplier: string[]
  expectedDate: string[] | null
  actualDate: string[] | null
}

interface ReservesFilterModel {
  lovId: string[]
  mnnId: string[]
  direction: string[]
  mnn: string[]
  dosage: string[]
  measure: string[]
  reject: string[]
  availability: string[]
  documents: string[]
  subDirection: string[]
  controlDate: string[] | null
}

interface ActionsFilterModel {
  actionTypes: string[],
  createdAt: string[],
  initiator: string[]
}

interface DistributionsMZUModel {
  lovId: string[],
  mnnId: string[],
  number: string[],
  createdAt: string[] | null,
  executor: string[],
  status: string[],
  direction: string[],
  subDirection: string[],
  signs: string[],
  documents: string[],
  mnn: string[],
  dosage: string[],
  tradeName: string[],
  distributedQuantity: number[],
  unitOfMeasure: string[],
  price: number[],
  totalPrice: number[],
  pdv: string[],
  totalPdv: number[],
  delivered: string[],
  priceOfDeliveredWithPdv: number[],
  warehouse: string[],
  refusal: string[],
  postponed: string[]
}

interface DistributionsDOZModel {
  number: string[],
  createdAt: string[],
  status: string[],
  direction: string[],
  subDirection: string[],
  mnn: string[],
  distributedQuantity: number[]
}

interface BasketModel {
  mnnId: string[],
  mnn: string[],
  dosage: string[],
  tradeName: string[],
  series: string[],
  quantity: number[],
  price: number[],
  totalPrice: number[],
  status: string[],
  refusal: string[]
}

export interface RecipientsDOZModel {
  direction: string[],
  shortListed: string[],
  experts: string[]
}

export interface RecipientsMZUModel {
  direction: string[],
  shortListed: string[],
  responsibleForDirection: string[]
}

export interface OrganizationsMZUModel {
  directions: string[],
  district: string[],
  name: string[],
  edrpou: string[],
  shortName: string[],
  address: string[],
  email: string[],
  manager: string[],
  responsiblePersons: string[],
  level: string[],
  type: string[],
  status: string[]
}

@Injectable({ providedIn: "root" })
export class FilterService {


  constructor(private http: HttpClient) {
  }

  showSuppliesFilter = false;
  showReservesFilter = false;
  showActionsFilter = false;
  goodSpecificationsShowed = false;
  distributionsMZUFilter = false;
  distributionsDOZFilter = false;
  basketFilter = false;
  organizationsFilter = false;
  recipientsFilter = false;

  supplies = {
    agreementNum: [],
    status: [],
    direction: [],
    subDirection: [],
    mnn: [],
    warehouse: [],
    supplier: [],
    expectedDate: [],
    actualDate: [],
  } as SuppliesFilterModel;

  reserves = {
    lovId: [],
    mnnId: [],
    direction: [],
    mnn: [],
    dosage: [],
    measure: [],
    reject: [],
    availability: [],
    documents: [],
    subDirection: [],
    controlDate: [],
  } as ReservesFilterModel;

  actions = {
    actionTypes: [],
    createdAt: [],
    initiator: []
  } as ActionsFilterModel;

  distributionsMZU = {
    lovId: [],
    mnnId: [],
    number: [],
    createdAt: [],
    executor: [],
    status: [],
    direction: [],
    subDirection: [],
    signs: [],
    documents: [],
    mnn: [],
    dosage: [],
    tradeName: [],
    distributedQuantity: [],
    unitOfMeasure: [],
    price: [],
    totalPrice: [],
    pdv: [],
    totalPdv: [],
    delivered: [],
    priceOfDeliveredWithPdv: [],
    warehouse: [],
    refusal: [],
    postponed: []
  } as DistributionsMZUModel

  distributionsDOZ = {
    number: [],
    createdAt: [],
    status: [],
    direction: [],
    subDirection: [],
    mnn: [],
    distributedQuantity: []
  } as DistributionsDOZModel;

  basket = {
    mnnId: [],
    mnn: [],
    dosage: [],
    tradeName: [],
    series: [],
    quantity: [],
    price: [],
    totalPrice: [],
    status: [],
    refusal: []
  } as BasketModel;

  recipientsDOZ = {
    direction: [],
    shortListed: [],
    experts: []
  } as RecipientsDOZModel;

  recipientsMZU = {
    direction: [],
    shortListed: [],
    responsibleForDirection: []
  } as RecipientsMZUModel;

  organizationsMZU = {
    directions: [],
    district: [],
    name: [],
    edrpou: [],
    shortName: [],
    address: [],
    email: [],
    manager: [],
    responsiblePersons: [],
    level: [],
    type: [],
    status: []
  } as OrganizationsMZUModel;

  suppliesSubject: BehaviorSubject<SuppliesFilterModel> = new BehaviorSubject(this.supplies);
  reservesSubject: BehaviorSubject<ReservesFilterModel> = new BehaviorSubject(this.reserves);
  actionsSubject: BehaviorSubject<ActionsFilterModel> = new BehaviorSubject(this.actions);
  distributionsMZUSubject: BehaviorSubject<DistributionsMZUModel> = new BehaviorSubject(this.distributionsMZU);
  distributionsDOZSubject: BehaviorSubject<DistributionsDOZModel> = new BehaviorSubject(this.distributionsDOZ);
  basketSubject: BehaviorSubject<BasketModel> = new BehaviorSubject(this.basket);
  recipientsDOZSubject: BehaviorSubject<RecipientsDOZModel> = new BehaviorSubject(this.recipientsDOZ);
  recipientsMZUSubject: BehaviorSubject<RecipientsMZUModel> = new BehaviorSubject(this.recipientsMZU);
  organizationsMZUSubject: BehaviorSubject<OrganizationsMZUModel> = new BehaviorSubject(this.organizationsMZU);

  suppliesOptions = {
    agreementNums: [],
    statuses: [
      {
        label: "Узгодження",
        value: "Узгодження",
      },
      {
        label: "Поставлено",
        value: "Поставлено",
      },
    ],
    directions: [
      {
        label: "Ювенільний ревматоїдний артрит",
        value: "Ювенільний ревматоїдний артрит",
      },
      {
        label: "Ідіопатична сімейна дистонія",
        value: "Ідіопатична сімейна дистонія",
      },
      {
        label: "Розсіяний склероз",
        value: "Розсіяний склероз",
      },
      {
        label: "Серцево-судинні захворювання",
        value: "Серцево-судинні захворювання",
      },
      {
        label: "Легенева артеріальна гіпертензія",
        value: "Легенева артеріальна гіпертензія",
      },
      {
        label: "Дитячий церебральний параліч",
        value: "Дитячий церебральний параліч",
      },
      {
        label: "Слухові апарати",
        value: "Слухові апарати",
      },
      {
        label: "ПЛР-тести COVID-19",
        value: "ПЛР-тести COVID-19",
      },
      {
        label: "Cлухопротезування",
        value: "Cлухопротезування",
      },
      {
        label: "Дитячі розлади психіки",
        value: "Дитячі розлади психіки",
      },
      {
        label: "Доросла онкологія",
        value: "Доросла онкологія",
      },
      {
        label: "Ендопротези",
        value: "Ендопротези",
      },
      {
        label: "Донорство крові",
        value: "Донорство крові",
      },
      {
        label: "Обладнання для центрів ядерної медицини",
        value: "Обладнання для центрів ядерної медицини",
      },
      {
        label: "Медична допомога в умовах воєнного стану",
        value: "Медична допомога в умовах воєнного стану",
      },
      {
        label: "Медвироби для ортопедії та нейрохірургії",
        value: "Медвироби для ортопедії та нейрохірургії",
      },
    ],
    subDirections: [
      {
        label: "Препарати для лікування онкологічних та онкогематологічних хворих",
        value: "Препарати для лікування онкологічних та онкогематологічних хворих",
      },
    ],
    mnns: [
      {
        label: "Гемцитабін",
        value: "Гемцитабін",
      },
    ],
    warehouses: [
      {
        label: "Укрмедпостач",
        value: "Укрмедпостач",
      },
      {
        label: "БЦФ",
        value: "БЦФ",
      },
    ],
    suppliers: [],
  };

  reservesOptions = {

  };

  actionOptions = {
    actionTypes: [
      {
        label: "Встановлення контрольної дати",
        value: "Встановлення контрольної дати"
      },
      {
        label: "Оновлення контрольної дати",
        value: "Оновлення контрольної дати"
      },
      {
        label: "Видалення мнн з розподілу",
        value: "Видалення мнн з розподілу"
      },
      {
        label: "Зміна статусу розподілу",
        value: "Зміна статусу розподілу"
      }
    ]
  }

  all: MedOptionType<string>[] = [
    {
      label: "Всі",
      value: "Всі",
    },
  ];

  directionOptions: any[] = [];

  public options(): MedOptionType<string>[] {
    return this.all;
  }

  suppliesPageHasFilters(): boolean {
    return  !!(this.supplies.mnn.length ||
            this.supplies.supplier.length ||
            this.supplies.warehouse.length ||
            this.supplies.status.length ||
            this.supplies.agreementNum.length ||
            this.supplies.direction.length ||
            this.supplies.subDirection.length ||
            (this.supplies.expectedDate && this.supplies.expectedDate.length) ||
            (this.supplies.actualDate && this.supplies.actualDate.length));
  }

  reservesPageHasFilters(): boolean {
    return !!(
      this.reserves.lovId.length ||
        this.reserves.mnnId.length ||
        this.reserves.direction.length ||
        this.reserves.mnn.length ||
        this.reserves.dosage.length ||
        this.reserves.measure.length ||
        this.reserves.reject.length ||
        this.reserves.availability.length ||
        this.reserves.documents.length ||
        this.reserves.subDirection.length ||
        (this.reserves.controlDate && this.reserves.controlDate.length)
    );
  }

  actionsPageHasFilters(): boolean {
    return !!(
        this.actions.actionTypes.length   ||
            this.actions.initiator.length ||
            this.actions.createdAt.length
    )
  }

  distributionsMZUHasFilters(): boolean {
    return !!(
     this.distributionsMZU.lovId.length ||
       this.distributionsMZU.mnnId.length ||
       this.distributionsMZU.number.length ||
       (this.distributionsMZU.createdAt && this.distributionsMZU.createdAt.length) ||
       this.distributionsMZU.executor.length ||
       this.distributionsMZU.status.length ||
       this.distributionsMZU.direction.length ||
       this.distributionsMZU.subDirection.length ||
       this.distributionsMZU.signs.length ||
       this.distributionsMZU.documents.length ||
       this.distributionsMZU.mnn.length ||
       this.distributionsMZU.dosage.length ||
       this.distributionsMZU.tradeName.length ||
       this.distributionsMZU.distributedQuantity.length ||
       this.distributionsMZU.unitOfMeasure.length ||
       this.distributionsMZU.price.length ||
       this.distributionsMZU.totalPrice.length ||
       this.distributionsMZU.pdv.length ||
       this.distributionsMZU.totalPdv.length ||
       this.distributionsMZU.delivered.length ||
       this.distributionsMZU.priceOfDeliveredWithPdv.length ||
       this.distributionsMZU.warehouse.length ||
       this.distributionsMZU.refusal.length ||
       this.distributionsMZU.postponed.length
    )
  }

  distributionsDOZHasFilters(): boolean {
    return !!(
      this.distributionsDOZ.number.length ||
      (this.distributionsDOZ.createdAt && this.distributionsDOZ.createdAt.length) ||
      this.distributionsDOZ.status.length ||
      this.distributionsDOZ.direction.length ||
      this.distributionsDOZ.subDirection.length ||
      this.distributionsDOZ.mnn.length ||
      this.distributionsDOZ.distributedQuantity.length
    )
  }

  recipientsDOZHasFilters(): boolean {
    return !!(
      this.recipientsDOZ.direction.length ||
      this.recipientsDOZ.shortListed.length ||
      this.recipientsDOZ.experts.length
    )
  }

  recipientsMZUHasFilters(): boolean {
    return !!(
      this.recipientsMZU.direction.length ||
      this.recipientsMZU.shortListed.length ||
      this.recipientsMZU.responsibleForDirection.length
    )
  }

  organizationsMZUHasFilters(): boolean {
    return !!(
      this.organizationsMZU.directions.length ||
      this.organizationsMZU.district.length ||
      this.organizationsMZU.name.length ||
      this.organizationsMZU.edrpou.length ||
      this.organizationsMZU.shortName.length ||
      this.organizationsMZU.address.length ||
      this.organizationsMZU.email.length ||
      this.organizationsMZU.manager.length ||
      this.organizationsMZU.responsiblePersons.length ||
      this.organizationsMZU.level.length ||
      this.organizationsMZU.type.length ||
      this.organizationsMZU.status.length
    );
  }

  filtersCount(path: string): number {
    let count = 0;
    if (path === "/supplies") {
      Object.entries(this.supplies)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .forEach(([key, value]) => {
          if (value && value.length) {
            count++;
          }
        });
    } else if (path === "/reserves") {
      Object.entries(this.reserves)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .forEach(([key, value]) => {
          if (value && value.length) {
            count++;
          }
        });
    } else if (path === "/actions") {
      Object.entries(this.actions)
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          .forEach(([key, value]) => {
            if (value.length) {
              count++;
            }
          });
    } else if (path === "/distributions/mzu") {
      Object.entries(this.distributionsMZU)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .forEach(([key, value]) => {
          if (value.length) {
            count++;
          }
        });
    } else if (path === "/distributions/doz") {
      Object.entries(this.distributionsDOZ)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .forEach(([key, value]) => {
          if (value.length) {
            count++;
          }
        });
    } else if (path === "/recipients") {
      Object.entries(this.recipientsDOZ)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .forEach(([key, value]) => {
          if (value.length) {
            count++;
          }
        });
      Object.entries(this.recipientsMZU)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .forEach(([key, value]) => {
          if (value.length) {
            count++;
          }
        });
    } else if (path === "/organizations") {
      Object.entries(this.organizationsMZU)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .forEach(([key, value]) => {
          if (value.length) {
            count++;
          }
        });
    }
    return count;
  }

  suppliesStateChanged() {
    this.supplies.supplier = this.supplies.supplier.filter(supplier => supplier);
    this.supplies.agreementNum = this.supplies.agreementNum.filter(supplier => supplier);
    this.supplies.status = this.supplies.status.filter(supplier => supplier);
    this.supplies.direction = this.supplies.direction.filter(supplier => supplier);
    this.supplies.subDirection = this.supplies.subDirection.filter(supplier => supplier);
    this.supplies.mnn = this.supplies.mnn.filter(supplier => supplier);
    this.supplies.warehouse = this.supplies.warehouse.filter(supplier => supplier);
    this.suppliesSubject.next(this.supplies);
  }

  reservesStateChanged() {
    this.reserves.subDirection = this.reserves.subDirection.filter(supplier => supplier);
    this.reserves.availability = this.reserves.availability.filter(supplier => supplier);
    this.reserves.measure = this.reserves.measure.filter(supplier => supplier);
    this.reserves.dosage = this.reserves.dosage.filter(supplier => supplier);
    this.reserves.direction = this.reserves.direction.filter(supplier => supplier);
    this.reserves.mnn = this.reserves.mnn.filter(supplier => supplier);
    this.reservesSubject.next(this.reserves);
  }

  actionsStateChanged() {
    this.actionsSubject.next(this.actions);
  }

  distributionsMZUStateChange() {
    this.distributionsMZUSubject.next(this.distributionsMZU);
  }

  distributionsDOZStateChange() {
    this.distributionsDOZSubject.next(this.distributionsDOZ);
  }

  basketStateChanged() {
    this.basketSubject.next(this.basket);
  }

  recipientsDOZStateChange() {
    this.recipientsDOZSubject.next(this.recipientsDOZ);
  }

  recipientsMZUStateChange() {
    this.recipientsMZUSubject.next(this.recipientsMZU);
  }

  organizationsMZUStateChange() {
    this.organizationsMZUSubject.next(this.organizationsMZU);
  }

  resetFilter(path: string) {
    if ("/supplies" === path) {
      this.supplies = {
        agreementNum: [],
        status: [],
        direction: [],
        subDirection: [],
        mnn: [],
        warehouse: [],
        supplier: [],
        expectedDate: [],
        actualDate: [],
      } as SuppliesFilterModel;
      this.suppliesStateChanged();
    } else if ("/reserves" === path) {
      this.reserves = {
        lovId: [],
        mnnId: [],
        direction: [],
        mnn: [],
        dosage: [],
        measure: [],
        reject: [],
        availability: [],
        documents: [],
        subDirection: [],
        controlDate: [],
      } as ReservesFilterModel;
      this.reservesStateChanged();
    } else if ("/actions" === path) {
      this.actions = {
        actionTypes: [],
        createdAt: [],
        initiator: []
      } as ActionsFilterModel;
      this.actionsStateChanged();
    } else if ("/distributions/mzu" === path) {
      this.distributionsMZU = {
        lovId: [],
        mnnId: [],
        number: [],
        createdAt: [],
        executor: [],
        status: [],
        direction: [],
        subDirection: [],
        signs: [],
        documents: [],
        mnn: [],
        dosage: [],
        tradeName: [],
        distributedQuantity: [],
        unitOfMeasure: [],
        price: [],
        totalPrice: [],
        pdv: [],
        totalPdv: [],
        delivered: [],
        priceOfDeliveredWithPdv: [],
        warehouse: [],
        refusal: [],
        postponed: []
      } as DistributionsMZUModel;
      this.distributionsMZUStateChange();
    } else if ("/recipients.doz" === path) {
      this.recipientsDOZ = {
        direction: [],
        shortListed: [],
        experts: []
      } as RecipientsDOZModel;
      this.recipientsDOZStateChange();
    } else if ("/recipients" === path) {
      this.recipientsMZU = {
        direction: [],
        shortListed: [],
        responsibleForDirection: []
      } as RecipientsMZUModel;
      this.recipientsMZUStateChange();
    } else if ("/organizations" === path) {
      this.organizationsMZU = {
        directions: [],
        district: [],
        name: [],
        edrpou: [],
        shortName: [],
        address: [],
        email: [],
        manager: [],
        responsiblePersons: [],
        level: [],
        type: [],
        status: []
      } as OrganizationsMZUModel;
      this.organizationsMZUStateChange();
    } else if ("/distributions/doz" === path) {
      this.distributionsDOZ = {
        number: [],
        createdAt: [],
        status: [],
        direction: [],
        subDirection: [],
        mnn: [],
        distributedQuantity: []
      } as DistributionsDOZModel;
      this.distributionsDOZStateChange();
    }
  }

  onLovIdChange(value: string, from: string): void {
    if (isNaN(Number(value)) || value.trim() === "") {
      if (from === 'reserves') {
        this.reserves.lovId = [];
      } else if (from === 'distributions/mzu') {
        this.distributionsMZU.lovId = [];
      }
    }
  }

  onMnnIdChange(value: string): void {
      this.reserves.mnnId = value.split(" ").filter(value => !isNaN(Number(value)) && value.trim());
  }

  onAvailabilityIdChange(value: string): void {
    if (isNaN(Number(value)) || value.trim() === "") {
      this.reserves.availability = [];
    }
  }

  loadDistinctsForDropdowns(): void {
    this.http.get<any>(env.logisticsServiceBackend + "/logistics/v1/goods/list?size=100").subscribe(data => {
      if (data && data.content) {
        this.suppliesOptions.mnns = [];
        data.content.forEach((val: string) => {
          this.suppliesOptions.mnns.push({ label: val, value: val });
        });
      }
    });


    this.suppliesOptions.directions = [];
    this.http.get<any>(env.logisticsServiceBackend + "/logistics/v1/reserve/directions").subscribe(data => {
      data.forEach((direct: any) => {
        const direction = {label: direct["shortName"], value: direct["id"]};
        if (!this.suppliesOptions.directions.includes(direction)) {
          this.suppliesOptions.directions.push(direction);
        }

      });
      this.suppliesOptions.directions.sort((a, b) => a.label.localeCompare(b.label));
    });
  }
}
